(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-category-header"]) return;
  try {
    
  class ShopCategoryScroll extends HTMLElement {
    connectedCallback() {
      this.strip = this.querySelector('nav');
      this.next = this.querySelector('button');
      this.update = () => { this.next.hidden = this.strip.scrollWidth - this.strip.clientWidth - this.strip.scrollLeft < 2; };
      this.next.onclick = () => this.strip.scrollBy({ left: this.strip.clientWidth * .65, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.strip.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.strip);
      const active = this.strip.querySelector('[aria-current="page"]');
      if (active && active !== this.strip.firstElementChild) this.strip.scrollLeft = Math.max(0, active.offsetLeft - 75);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.strip?.removeEventListener('scroll', this.update);
    }
  }
  if (!customElements.get('shop-category-scroll')) customElements.define('shop-category-scroll', ShopCategoryScroll);

  } catch(e) { console.error(e); }
})();
})();
